import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth0 } from '../components/auth/DevAuth0Provider';
import { fetchAlerts } from '../api/alertApi'; // Assuming this API function exists and is correct

const AlertsContext = createContext();

export const AlertsProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const loadAlerts = useCallback(async () => {
    if (!isAuthenticated) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const fetchedAlerts = await fetchAlerts(getAccessTokenSilently);
      setAlerts(fetchedAlerts || []);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [getAccessTokenSilently, isAuthenticated]);

  useEffect(() => {
    // Only load alerts if authenticated and not loading
    if (isAuthenticated) {
      loadAlerts();
    } else {
      setIsLoading(false);
    }
  }, [isAuthenticated, loadAlerts]);

  const value = { alerts, isLoading, error, refreshAlerts: loadAlerts };

  return (
    <AlertsContext.Provider value={value}>
      {children}
    </AlertsContext.Provider>
  );
};

export const useAlerts = () => useContext(AlertsContext);
